import { Flex, Heading, HeadingProps } from "@chakra-ui/react";
import { FunctionComponent, ReactNode } from "react";

interface SectionHeaderProps {
    title: string;
    children?: ReactNode;
    headingProps?: HeadingProps;
}

export const SectionHeader: FunctionComponent<SectionHeaderProps> = ({ title, children, headingProps = {} }) => {
    return (
        <Flex flexFlow="row nowrap" alignItems="center" gap="2rem">
            <Heading fontWeight={700} margin="0" flex="1 1 100%" {...headingProps}>
                {title}
            </Heading>
            {children}
        </Flex>
    );
};
